export const TXN_OVERVIEW = 'fasTag/detail/TXN_OVERVIEW';
export const SET_TXN_OVERVIEW = 'fasTag/detail/SET_TXN_OVERVIEW';
export const FETCH_TRANSACTIONS = 'fasTag/detail/FETCH_TRANSACTIONS';
export const SET_TRANSACTION_DETAILS = 'fasTag/detail/SET_TRANSACTION_DETAILS';
export const RESET = 'fasTag/detail/RESET';
export const SET_VEHICLE_DETAIL = 'fasTag/detail/SET_VEHICLE_DETAIL';
export const DOWNLOAD_TRANSACTIONS = 'fasTag/DOWNLOAD_TRANSACTIONS';
export const DOWNLOAD_ALL_TRANSACTIONS = 'fasTag/DOWNLOAD_ALL_TRANSACTIONS';
